import React, {useEffect, useState, useRef} from "react";
import {adminGetOrders, adminUpdateOrderStatus} from "../../api";
import "./AdminLayout.css";
import {useParams, useNavigate} from "react-router-dom";

const ORDER_STATUSES = [
  "placed",
  "confirmed",
  "shipped",
  "delivered",
  "cancelled",
];
const STATUS_COLORS = {
  placed: "badge-blue",
  confirmed: "badge-yellow",
  shipped: "badge-yellow",
  delivered: "badge-green",
  cancelled: "badge-red",
};

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);
  const [updating, setUpdating] = useState(null);

  const navigate = useNavigate(); // ← add th

  useEffect(() => {
    adminGetOrders()
      .then((r) => {
        console.log("Check the orders", r.data);

        setOrders(r.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  async function handleStatusChange(orderId, field, value) {
    setUpdating(orderId);
    try {
      const {data} = await adminUpdateOrderStatus(orderId, {[field]: value});
      setOrders((prev) => prev.map((o) => (o._id === orderId ? data : o)));
    } catch {
      alert("Update failed");
    } finally {
      setUpdating(null);
    }
  }
  async function saveWaybill(order, waybill) {
    const data = {waybill: waybill.trim()};
    // Handing the parcel to Delhivery means it has shipped
    if (data.waybill && ["placed", "confirmed"].includes(order.orderStatus))
      data.orderStatus = "shipped";
    setUpdating(order._id);
    try {
      const res = await adminUpdateOrderStatus(order._id, data);
      setOrders((prev) => prev.map((o) => (o._id === order._id ? res.data : o)));
    } catch {
      alert("Update failed");
    } finally {
      setUpdating(null);
    }
  }

  const waWindowRef = useRef(null);
  return (
    <div>
      <div className="admin-page-header">
        <div>
          <h1 className="admin-page-title">Orders</h1>
          <p className="admin-page-sub">{orders.length} total orders</p>
        </div>
      </div>

      <div style={{padding: "16px 28px 28px"}}>
        <div className="admin-card">
          {loading ? (
            <div className="admin-loading">Loading orders…</div>
          ) : orders.length === 0 ? (
            <div className="empty-state">
              <span>🛒</span>
              <p>No orders yet.</p>
            </div>
          ) : (
            <div className="admin-table-wrap">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Order #</th>
                    <th>Customer</th>
                    <th>Items</th>
                    <th>Total</th>
                    <th>Payment</th>
                    <th>Payment Status</th>
                    <th>Order Status</th>
                    <th>Date</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order) => (
                    <React.Fragment key={order._id}>
                      <tr>
                        <td>
                          <strong style={{fontFamily: "monospace"}}>
                            {order.orderNumber}
                          </strong>
                        </td>
                        <td>
                          <div style={{fontSize: 14}}>
                            {order.shippingAddress?.name}
                          </div>
                          <div style={{fontSize: 12, color: "#9ca3af"}}>
                            {order.shippingAddress?.phone}
                          </div>
                        </td>
                        <td style={{color: "#6b7280"}}>
                          {order.items?.length} item
                          {order.items?.length !== 1 ? "s" : ""}
                          {order.freeGift && (
                            <div title="Include a surprise gift">🎁 + Gift</div>
                          )}
                        </td>
                        <td>
                          <strong>
                            ₹{order.total?.toLocaleString("en-IN")}
                          </strong>
                        </td>
                        <td>
                          <span
                            className="badge badge-gray"
                            style={{textTransform: "capitalize"}}
                          >
                            {order.paymentMethod}
                          </span>
                        </td>
                        <td>
                          <select
                            value={order.orderStatus}
                            disabled={updating === order._id}
                            onChange={(e) =>
                              handleStatusChange(
                                order._id,
                                "orderStatus",
                                e.target.value,
                              )
                            }
                            style={{
                              border: "1px solid #d1d5db",
                              borderRadius: 6,
                              padding: "5px 8px",
                              fontSize: 13,
                              cursor: "pointer",
                            }}
                          >
                            {ORDER_STATUSES.map((s) => (
                              <option key={s} value={s}>
                                {s.charAt(0).toUpperCase() + s.slice(1)}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td>{order.paymentStatus}</td>
                        <td style={{fontSize: 13, color: "#9ca3af"}}>
                          {new Date(order.createdAt).toLocaleDateString(
                            "en-IN",
                          )}
                        </td>
                        <td>
                          <button
                            className="btn-icon"
                            onClick={() =>
                              setExpanded(
                                expanded === order._id ? null : order._id,
                              )
                            }
                          >
                            {expanded === order._id ? "▲" : "▼"}
                          </button>
                        </td>
                        <td>
                          <button
                            className="btn-primary"
                            style={{
                              fontSize: 12,
                              padding: "6px 12px",
                              display: "flex",
                              alignItems: "center",
                              gap: 4,
                            }}
                            title="Print shipping label"
                            onClick={
                              () =>
                                window.open(
                                  `/admin/orders/${order.orderNumber}/label`,
                                  "_blank",
                                )
                              // navigate(
                              //   `/admin/orders/${order.orderNumber}/label`,
                              // )
                            }
                          >
                            🖨️ Label
                          </button>
                        </td>
                        <td>
                          <button
                            className="btn-icon"
                            onClick={() => {
                              let includePayment = false;
                              let showItems = false;
                              console.log("b", order);

                              let phone = order.shippingAddress.phone.replace(
                                /[\s+\-]/g,
                                "",
                              );
                              if (phone.startsWith("0")) phone = phone.slice(1);
                              if (!phone.startsWith("91")) phone = "91" + phone;
                              const message = `✅ *Order Confirmed!* \n
*Variant Exclusive*

Hi ${order.shippingAddress.name}! 👋

Your order has been placed successfully.

🧾 *Order:* ${order.orderNumber}
💰 *Amount:* ₹${order.total?.toLocaleString("en-IN")}

📍 *Delivering to:*
${order.shippingAddress.city}, ${order.shippingAddress.state} — ${order.shippingAddress.pincode}

🚚 Estimated dispatch: 3–7 business days

Thank you for shopping with us! 🙏
_variantexclusive.com_`;
                              // const message = `Hi ${order.customerName}, this is regarding your order #${order.orderId} from Variant Exclusive. `;
                              const url = `https://web.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`;

                              if (
                                waWindowRef.current &&
                                !waWindowRef.current.closed
                              ) {
                                waWindowRef.current.location.href = url;
                                waWindowRef.current.focus();
                              } else {
                                waWindowRef.current = window.open(
                                  url,
                                  "whatsapp_admin_window",
                                );
                              }
                            }}
                          >
                            Send WhatsApp message
                          </button>
                        </td>
                      </tr>

                      {/* Expandable detail row */}
                      {expanded === order._id && (
                        <tr>
                          <td
                            colSpan={8}
                            style={{
                              background: "#f9fafb",
                              padding: "16px 20px",
                            }}
                          >
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: 20,
                              }}
                            >
                              {/* Items */}
                              <div>
                                <p
                                  style={{
                                    fontSize: 12,
                                    fontWeight: 700,
                                    color: "#6b7280",
                                    textTransform: "uppercase",
                                    marginBottom: 8,
                                  }}
                                >
                                  Items ordered
                                </p>
                                {order.items?.map((item, i) => (
                                  <div
                                    key={i}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: 13,
                                      padding: "4px 0",
                                      borderBottom: "1px solid #e5e7eb",
                                    }}
                                  >
                                    <span>
                                      {item.name} × {item.quantity}
                                      {item.customName && (
                                        <span
                                          style={{
                                            display: "block",
                                            fontSize: 12,
                                            color: "#b45309",
                                            fontWeight: 600,
                                          }}
                                        >
                                          Custom name: {item.customName}
                                        </span>
                                      )}
                                    </span>
                                    <span>
                                      ₹
                                      {(
                                        item.price * item.quantity
                                      ).toLocaleString("en-IN")}
                                    </span>
                                  </div>
                                ))}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    fontSize: 13,
                                    fontWeight: 700,
                                    marginTop: 8,
                                  }}
                                >
                                  <span>Total</span>
                                  <span>
                                    ₹{order.total?.toLocaleString("en-IN")}
                                  </span>
                                </div>
                              </div>
                              {/* Address */}
                              <div>
                                <p
                                  style={{
                                    fontSize: 12,
                                    fontWeight: 700,
                                    color: "#6b7280",
                                    textTransform: "uppercase",
                                    marginBottom: 8,
                                  }}
                                >
                                  Shipping address
                                </p>
                                <p style={{fontSize: 13, lineHeight: 1.7}}>
                                  {order.shippingAddress?.name}
                                  <br />
                                  {order.shippingAddress?.phone}
                                  <br />
                                  {order.shippingAddress?.email && (
                                    <>
                                      {order.shippingAddress.email}
                                      <br />
                                    </>
                                  )}
                                  {order.shippingAddress?.addressLine1}
                                  {order.shippingAddress?.addressLine2
                                    ? `, ${order.shippingAddress.addressLine2}`
                                    : ""}
                                  <br />
                                  {order.shippingAddress?.city},{" "}
                                  {order.shippingAddress?.state} —{" "}
                                  {order.shippingAddress?.pincode}
                                </p>
                              </div>
                            </div>
                            {/* Delhivery waybill */}
                            <form
                              key={order.waybill || ""}
                              onSubmit={(e) => {
                                e.preventDefault();
                                saveWaybill(order, e.target.waybill.value);
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                marginTop: 16,
                                fontSize: 13,
                              }}
                            >
                              <label
                                htmlFor={`waybill-${order._id}`}
                                style={{fontWeight: 700, color: "#6b7280"}}
                              >
                                Delhivery AWB
                              </label>
                              <input
                                id={`waybill-${order._id}`}
                                name="waybill"
                                defaultValue={order.waybill || ""}
                                placeholder="Waybill number"
                                style={{
                                  border: "1px solid #d1d5db",
                                  borderRadius: 6,
                                  padding: "6px 10px",
                                  fontSize: 13,
                                  fontFamily: "monospace",
                                }}
                              />
                              <button
                                type="submit"
                                className="btn-primary"
                                style={{fontSize: 12, padding: "6px 12px"}}
                                disabled={updating === order._id}
                              >
                                Save
                              </button>
                              {order.waybill && (
                                <a
                                  href={`/track-order?order=${order.orderNumber}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View tracking page
                                </a>
                              )}
                            </form>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
